import * as React from "react"
import { Grid } from "@mui/material"

import AdminSkuFormAvailable from "./Available"
import AdminSkuFormBrand from "./Brand"
import AdminSkuFormCategory from "./Category"
import AdminSkuFormEAN from "./Ean"
import AdminSkuFormSkuImage from "./Image"
import AdminSkuFormSkuImageURL from "./ImageURL"
import AdminSkuFormSkuName from "./SkuName"


export default function AdminSkuDrawerContent() {
    return <Grid container spacing={2}>
        <Grid item xs={12}>
            <AdminSkuFormCategory />
        </Grid>

        <Grid item xs={12}>
            <AdminSkuFormBrand />
        </Grid>

        <Grid item xs={12}>
            <AdminSkuFormSkuName />
        </Grid>

        <Grid item xs={6}>
            <AdminSkuFormEAN />
        </Grid>

        <Grid item xs={3}>
            <AdminSkuFormAvailable
                label="Pricing"
                availableType="availablePricing"
            />
        </Grid>

        <Grid item xs={3}>
            <AdminSkuFormAvailable
                label="Marketplaces"
                availableType="availableMarketplaces"
            />
        </Grid>

        <Grid item xs={4}>
            <AdminSkuFormSkuImage />
        </Grid>

        <Grid item xs={8}>
            <AdminSkuFormSkuImageURL />
        </Grid>
    </Grid>
}